var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6406 9.39062H4.48438C3.60417 9.39062 2.89062 10.1042 2.89062 10.9844V16.5625C2.89062 17.4427 3.60417 18.1562 4.48438 18.1562H15.6406C16.5208 18.1562 17.2344 17.4427 17.2344 16.5625V10.9844C17.2344 10.1042 16.5208 9.39062 15.6406 9.39062Z",
    stroke: "#00507C",
    strokeWidth: 1.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07812 9.39062V6.20312C6.07813 5.1464 6.49791 4.13296 7.24512 3.38575C7.99234 2.63853 9.00578 2.21875 10.0625 2.21875C11.1192 2.21875 12.1327 2.63853 12.8799 3.38575C13.6271 4.13296 14.0469 5.1464 14.0469 6.20312V9.39062",
    stroke: "#00507C",
    strokeWidth: 1.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2a410568401a379628606067c44a3265.svg";
export { ForwardRef as ReactComponent };